<template style="height:100%">
  <div class="Monthly_statistics">
    <el-tabs style="width: 98%;margin-left:1%" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="人次统计" name="first">

        <div>
          <span style="padding-right:20px">日期</span>
          <el-date-picker v-model="value1" value-format="yyyy-MM" type="month" placeholder="选择月">
          </el-date-picker>
        </div>

        <el-table :data="tableData.monthPeople" style="width: 100%;margin-top:20px">
          <el-table-column  prop="campus" label="校区"></el-table-column>
          <el-table-column  prop="reserve" label="预约人次"></el-table-column>
          <el-table-column  prop="done" label="完成人次"></el-table-column>
          <el-table-column  prop="done_offline" label="线下完成人数"></el-table-column>
          <el-table-column  prop="done_online" label="线上完成人数"></el-table-column>
          <el-table-column  prop="wait" label="排队人数"></el-table-column>
          <el-table-column  prop="schedule" label="可预约排班数"></el-table-column>
        </el-table>
      </el-tab-pane>

      <el-tab-pane label="学历统计" name="second">
        <div>
          <span style="padding-right:20px">日期</span>
          <el-date-picker v-model="value1" value-format="yyyy-MM" type="month" placeholder="选择月">
          </el-date-picker>
        </div>
        <el-table :data="tableData.monthDegrees" style="width: 100%;margin-top:20px">
          <el-table-column prop="degree" label="学历"></el-table-column>
          <el-table-column prop="count" label="数量"></el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="咨询主题统计" name="third">

        <div>
          <span style="padding-right:20px">日期</span>
          <el-date-picker v-model="value1" value-format="yyyy-MM" type="month" placeholder="选择月">
          </el-date-picker>
        </div>

        <el-table :data="tableData.monthConsultTheme" style="width: 100%;margin-top:20px">
          <el-table-column prop="love" label="恋爱问题"></el-table-column>
          <el-table-column prop="interpersonal" label="人际交往问题"></el-table-column>
          <el-table-column prop="emotionalor" label="情绪压力问题"></el-table-column>
          <el-table-column prop="academic" label="学业咨询"></el-table-column>
          <el-table-column prop="graduation" label="毕业就业问题"></el-table-column>
          <el-table-column prop="marriage" label="婚姻家庭问题"></el-table-column>
          <el-table-column prop="sexual" label="性问题"></el-table-column>
          <el-table-column prop="psychological" label="心理危机"></el-table-column>
          <el-table-column prop="other" label="其他"></el-table-column>
        </el-table>
        
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeName: 'first',
      value1:'',
      value2:'',
      value3:'',
      tableData:'',
    };
  },
  components:{

  },
  methods: {
    handleClick(tab, event) {
      if(tab.label == '人次统计'){
        this.load1(this.value1)
      }else if(tab.label == '学历统计'){
        this.load1(this.value2)
      }else if(tab.label == '咨询主题统计'){
        this.load1(this.value3)
      }
    },
    load1(time){
      this.$Http_Post('ConsultSubscribe/GetMonthStatistics', { Month:time }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.tableData = res.Data;
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    }
  },

  created() {

  },

  mounted() {
    this.load1('')
  }
};
</script>
<style>
.Monthly_statistics{width: 100%;height: 100%;background-color: #fff;}
</style>